export default "__VITE_ASSET__nWN97$8x__"